<!-- Please don’t change these IDs because those are for automated testing: createMapBtn, searchMapInput, mapLoadMoreBtn, editMapBtn, chooseMapBtn, cancelMapBtn -->
<div class="choose-map-pop--in">
  <button class="choose-map-pop-close" (click)="closePopUp()"><img src="../../../../../../assets/images/svg_icons/cross.svg" alt="Close"  /></button>
  <div class="choose-map-pop--top">
    <h1>{{ translations.CHOOSE_MAP.CHOOSE | translate }}</h1>
    <div class="add-map-btn">
      <a id="createMapBtn" href="javascript:void(0)" (click)="setModeAsAddMode()">
        {{ translations.CHOOSE_MAP.CREATE | translate }}
        <svg width="100%" height="100%" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.5 9.5H5M9.5 5V9.5V5ZM9.5 9.5V14V9.5ZM9.5 9.5H14H9.5Z" stroke="#FE6C0B" stroke-width="1.5"/>
          <path d="M9.49998 17.4167C13.8722 17.4167 17.4166 13.8723 17.4166 9.50001C17.4166 5.12776 13.8722 1.58334 9.49998 1.58334C5.12773 1.58334 1.58331 5.12776 1.58331 9.50001C1.58331 13.8723 5.12773 17.4167 9.49998 17.4167Z" stroke="#FE6C0B" stroke-width="1.5"/>
        </svg>
      </a>
    </div>
  </div>
  <div class="choose-map-pop--container" [ngClass]="{'choose-map-pop--container--height': isInfoModeEnabled || isChooseModeEnabled}">
    <div class="choose-map-pop-left">
      <div class="choose-map-search">
        <app-text-search id="searchMapInput"
          [placeholder]="getTranslations(translations.CHOOSE_MAP.SEARCH_EXISTING_MAP)"
          (textSearchTriggered)="searchByText($event)">
        </app-text-search>
      </div>
      <div class="exisiting-map-list"  [ngClass]="{'scroll-heigth-info-mode-enabled': isInfoModeEnabled || isChooseModeEnabled}">
        <ul>
          @for (mapItem of mapList; track mapItem; let mapIndex = $index) {
            <li
              (click)="viewMapDetails(mapIndex)"
						[ngClass]="{'active': (isEditModeEnabled || isChooseModeEnabled) && 
							chosenIndex === mapIndex}">
              <label for="{{mapItem._id}}">
                <input type="radio" id="{{mapItem._id}}"> {{mapItem.name}} </label>
              </li>
            }
          </ul>
          @if (mapList?.length===0) {
            <div class="not-found not-found-message">
              {{translations.GLOBAL.ERROR_MESSAGES.NO_RECORD_FOUND | translate}}
            </div>
          }
        </div>
        <div class="map-list-load-btn">
          @if (totalMapCount != mapList?.length) {
            <a class="orange-btn_outline" id="mapLoadMoreBtn"
              (click)="loadMoreMaps()">
              {{translations.GLOBAL.KEYS.LOAD_MORE | translate}}
            </a>
          }

        </div>
      </div>
      <div class="choose-map-pop-right">
        @if (isInfoModeEnabled) {
          <div class="no-map-details">
            <h2>
              {{translations.CHOOSE_MAP.SELECT_EXISTING_MAP_CREATE_NEW | translate}}
            </h2>
          </div>
        }
        @if (isAddModeEnabled || isEditModeEnabled) {
          <div class="choose-map-pop-form">
            <app-map-form #mapForm
              [token]="token"
              [mapToBeEdited]="mapList[chosenIndex]"
              (mapFormClosed)="closePopUp()"
              (mapCreated)="chooseMap($event)"
              (mapCreationErrorOccured)="showErrorMessageForMapCreation()"
              (mapUpdated)="chooseMap($event)"
              (mapUpdationErrorOccured)="showErrorMessageForMapUpdation()">
            </app-map-form>
          </div>
        }
        @if (isChooseModeEnabled && chosenMap) {
          <div class="choose-map-details">
            <div class="choose-map-details-top">
              <h4>{{translations.GLOBAL.KEYS.CHALLENGE_MAP | translate}}</h4>
              @if (doesChosenMapLieInList()) {
                <div class="edit-map-btn">
                  <a id="editMapBtn" href="javascript:void(0)" (click)="editMap(chosenIndex)">
                    {{translations.MAP.EDIT | translate}}
                    <svg width="100%" height="100%" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.8989 1.10037C14.4355 -0.366789 12.0557 -0.366789 10.5924 1.10037L0.863173 10.8271C0.78711 10.9031 0.740009 11.001 0.725518 11.106L0.00473397 16.4457C-0.0170017 16.5979 0.0373448 16.75 0.142389 16.8551C0.232942 16.9457 0.359696 17 0.486476 17C0.508211 17 0.52996 17 0.551696 16.9964L3.76815 16.5617C4.03619 16.5254 4.22455 16.2791 4.18833 16.011C4.1521 15.743 3.90585 15.5546 3.63781 15.5908L1.05874 15.9386L1.56222 12.2145L5.48147 16.1342C5.57202 16.2248 5.69878 16.2791 5.82556 16.2791C5.95234 16.2791 6.07909 16.2284 6.16964 16.1342L15.8989 6.40749C16.6088 5.69746 17 4.75558 17 3.75212C17 2.74866 16.6088 1.80678 15.8989 1.10037ZM10.7807 2.29583L12.4143 3.92962L3.53632 12.8086L1.90275 11.1748L10.7807 2.29583ZM5.82921 15.0981L4.23181 13.5006L13.1098 4.62154L14.7072 6.21911L5.82921 15.0981ZM15.3882 5.51995L11.4798 1.61116C11.976 1.2018 12.5955 0.977199 13.2474 0.977199C13.99 0.977199 14.6855 1.26701 15.2107 1.78866C15.7359 2.31032 16.022 3.00948 16.022 3.75212C16.022 4.40781 15.7975 5.02365 15.3882 5.51995Z" fill="#FE6C0B"/>
                    </svg>
                  </a>
                </div>
              }
            </div>
            <div class="choose-map-details-btm">
              <div class="row">
                <div class="col-sm-6">
                  <div class="choose-map-info">
                    <span>{{ translations.MAP.TITLE | translate}}</span>
                    <strong> {{chosenMap.name}} </strong>
                  </div>
                  <div class="choose-map-info">
                    <span>{{ translations.MAP.MAP_TYPE | translate}}</span>
                    <strong>
                      {{ translations.GLOBAL.KEYS[mapTypeDetails[chosenMap.mapType].Label] | translate}}
                    </strong>
                  </div>
                  <div class="choose-map-info">
                    <span>{{translations.MAP.START_LOCATION | translate}}</span>
                    <strong>
                      {{getStartLocationOfMap(chosenMap)}}
                    </strong>
                  </div>
                  @if (isMapAutomatic(chosenMap.mapType)) {
                    <div class="choose-map-info">
                      <span>{{translations.MAP.END_LOCATION | translate}}</span>
                      <strong>
                        {{getEndLocationOfMap(chosenMap)}}
                      </strong>
                    </div>
                  }
                  <div class="choose-map-info">
                    <span>{{translations.GLOBAL.KEYS.STATUS | translate}}</span>
                    <strong>
                      {{getStatusLabelFromStatusNumber(chosenMap.status)}}
                    </strong>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="choose-map-info choose-map-border">
                    <app-custom-route-map-preview
                      [areMapTypeControlsHidden]="true"
                      [panelClass]="'choose-popup-map-view'"
                      [destination]="selectedMapDestination"
                      [mapType]="chosenMap.mapType"
                      [mode]="mapMode.VIEW"
                      [initialMarkersValue]="chosenMapMarkers"
                      [origin]="chosenMap.origin"
                      [token]="token">
                    </app-custom-route-map-preview>
                  </div>
                </div>
              </div>
              <div class="choose-map-pop-bottom">
                <button class="orange-btn_outline" id="chooseMapBtn" (click)="chooseMap(chosenMap)">
                  {{translations.GLOBAL.KEYS.CHOOSE | translate}}
                </button>
                <button type="button" id="cancelMapBtn" class="gray-btn_outline" data-dismiss="modal" (click)="closePopUp()">
                  {{translations.GLOBAL.KEYS.CANCEL | translate}}
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
